import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';

export default function SubmitButton(props) {
  const {
    isPurchasing,
    isWaitingForReCaptcha,
    isWaitingForInstance,
    selectedPackage,
    onClick,
  } = props;

  const disabled = isPurchasing || isWaitingForInstance || isWaitingForReCaptcha || (!selectedPackage);

  return (
    <button
      className="button button--secondary"
      type="submit"
      onClick={onClick}
      disabled={disabled}
    >
      <ButtonLabel {...props} />
    </button>
  );
}

SubmitButton.displayName = 'SubmitButton';

SubmitButton.propTypes = {
  isPurchasing: PropTypes.bool.isRequired,
  isWaitingForInstance: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedPackage: PropTypes.shape({ quantity: PropTypes.number.isRequired }),
};

SubmitButton.defaultProps = {
  selectedPackage: undefined,
};


function ButtonLabel(props) {
  if (props.isPurchasing || props.isWaitingForInstance) {
    return <Loading spinner small />;
  }
  if (props.selectedPackage) {
    return `Buy ${props.selectedPackage.quantity} FATE`;
  }
  return 'Complete purchase';
}